import SettingsWrapper from '../settings/SettingsWrapper.vue';
import Index from './Index.vue';
export const routes = [
  {
    path: 'finance',
    component: SettingsWrapper,
    props: { keepAlive: false },
    meta: { permissions: ['administrator'] },
    children: [
      {
        path: '',
        name: 'telegram_finance',
        component: Index,
        meta: { permissions: ['administrator'] },
      },
    ],
  },
];
